import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import topLogo from "../../../../../assets/top/top_logo.png";
import nightmenuImage from "../../../../../assets/nightmenu.jpg";
import nightmukuImage from "../../../../../assets/Nightmuku2.jpg";
import alcholeImage from "../../../../../assets/alchole.jpg";
import softdrinkImage from "../../../../../assets/softdrink.jpg";
import {
  container,
  innerContainer,
  menuSection,
  mainSection,
  imageContainer,
  menuImage,
  menuImageContent,
  imageTextOverlay,
  overlayTitle,
  overlayDescription,
  contentContainer,
  menuCategories,
  categoryCard,
  categoryTitle,
  categoryTitleEn,
  menuContent,
  menuLogo,
  activeCard,
  foodItemWrapper,
  foodText,
  foodImage,
  foodImageContent,
  foodTitle,
  foodDescription,
  foodNote,
  drinkCarouselWrapper,
  drinkItem,
  drinkImage,
  drinkTitle,
  drinkSub
} from "../menuPage.css.ts";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
// @ts-ignore
import "swiper/css";
// @ts-ignore
import "swiper/css/autoplay";
import MenuSection from "../components/MenuSection";
import MobileHeader from "../components/MobileHeader";

// 画面幅判定用フック
function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(false);
  React.useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= breakpoint);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, [breakpoint]);
  return isMobile;
}

interface MenuItem {
  title: string;
  description?: string;
  price?: string;
  image?: string;
  subTitle?: string;
}

interface MenuItems {
  food: MenuItem[];
  drink: MenuItem[];
}

const DinnerMenuPage: React.FC = () => {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState<keyof MenuItems>('food');
  const isMobile = useIsMobile();

  const tabSections = [
    { id: 'food', label: 'お食事', en: 'FOOD' },
    { id: 'drink', label: 'ドリンク', en: 'DRINK' }
  ];

  const menuItems: MenuItems = {
    food: [
      {
        title: 'お任せコース',
        description: '季節の食材を活かした、当店自慢のコース料理をお楽しみください。',
        price: '¥5,400(税込)',
        image: nightmenuImage
      }
    ],
    drink: [
      {
        title: 'アルコール',
        description: '生ビールのほか、厳選の日本酒、泡盛、ナチュラルワイン、みぞれ梅酒など自信を持ってお勧めできるアルコールをご用意しております。',
        price: '¥750〜',
        image: alcholeImage,
        subTitle: 'nihonsyu',
      },
      {
        title: 'ソフトドリンク',
        description: 'ノンアルコールビール、100％ブドウ・リンゴ・ブラッドオレンジ他ソフトドリンクもご用意しております。',
        price: '¥600～',
        image: softdrinkImage,
        subTitle: 'natural wine',
      }
    ]
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={container}>
      <div className={innerContainer}>
        <MobileHeader />
        <div className={menuSection}>
          <img
            src={topLogo}
            alt="キッチンムク"
            className={menuLogo}
            onClick={() => navigate('/')} 
            style={{ cursor: 'pointer' }}
          />
          <MenuSection />
        </div>
        <div className={mainSection}>
          <div className={imageContainer}>
            <div className={menuImage}>
              <img
                src={nightmukuImage}
                alt="dinner"
                className={menuImageContent}
              />
              <div className={imageTextOverlay}>
                <h1 className={overlayTitle}>夜ムク</h1>
                <p className={overlayDescription}>
                シェフお任せコースと厳選アルコールで特別ななひとときをお楽しみください。
                </p>
              </div>
            </div>
          </div>
          <div className={contentContainer}>
            <div className={menuCategories}>
              {tabSections.map((section) => (
                <div
                  key={section.id}
                  className={`${categoryCard} ${section.id === activeCategory ? activeCard : ''}`}
                  onClick={() => setActiveCategory(section.id as keyof MenuItems)}
                >
                  <h2 className={categoryTitle}>{section.label}</h2>
                  <span className={categoryTitleEn}>{section.en}</span>
                </div>
              ))}
            </div>
            <div className={menuContent}>
              {activeCategory === 'drink' ? (
                isMobile ? (
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "16px",
                      width: "100%",
                    }}
                  >
                    {menuItems.drink.map((item, idx) => (
                      <div key={idx} className={drinkItem}>
                        <img src={item.image} alt={item.title} className={drinkImage} />
                        <div className={drinkTitle}>{item.title}</div>
                        <div className={drinkSub}>{item.subTitle || ''}</div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className={drinkCarouselWrapper}>
                    <Swiper
                      modules={[Autoplay]}
                      spaceBetween={32}
                      slidesPerView={"auto"}
                      loop={true}
                      freeMode={true}
                      autoplay={{
                        delay: 0,
                        disableOnInteraction: false,
                      }}
                      speed={4000}
                      allowTouchMove={false}
                      style={{ width: "100%" }}
                    >
                      {menuItems.drink.map((item, idx) => (
                        <SwiperSlide
                          key={idx}
                          style={{ width: 320, display: "flex", justifyContent: "center" }}
                        >
                          <div className={drinkItem}>
                            <img src={item.image} alt={item.title} className={drinkImage} />
                            <div className={drinkTitle}>{item.title}</div>
                            <div className={drinkSub}>{item.subTitle || ''}</div>
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                )
              ) : (
                menuItems.food.map((item, idx) => (
                  <div key={idx} className={foodItemWrapper}>
                    {isMobile ? (
                      <div className={foodText} style={{ width: "100%" }}>
                        <div className={foodTitle}>{item.title}</div>
                        <div className={foodImage}>
                          <img src={item.image} alt={item.title} className={foodImageContent} />
                        </div>
                        <div className={foodDescription}>{item.description}</div>
                        <div className={foodNote}>{item.price}</div>
                      </div>
                    ) : (
                      <>
                        <div className={foodText}>
                          <div className={foodTitle}>{item.title}</div>
                          <div className={foodDescription}>{item.description}</div>
                          <div className={foodNote}>{item.price}</div>
                        </div>
                        <div className={foodImage}>
                          <img src={item.image} alt={item.title} className={foodImageContent} />
                        </div>
                      </>
                    )}
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DinnerMenuPage; 